<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thank you to the three women who truly shaped me, serving as my pillars and guiding lights: my mother, Sheri Marzaro, my aunt, Karen Fisch, and my godmother, Ileana Stahl. I hope to embody even an ounce of your strength, grace, resilience and kindness.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5e6f3019